const map = require('lodash/fp/map');
const dateFormat = require('date-fns/format');
const memoizer = require('../request-handler/utils/memoizer');

function parseIncomeOverviewData(data){
  const oReturn = {
    year: map(parseYTDData)(data.ytdChartAggregate),
    month: map(parseMonthData)(data.mthChartAggregate),
    week: map(parseWeekData)(data.wkChartAggregate), 
    prodIncAggregateBean: data.prodIncAggregateBean,
    prodExpAggregateBean: data.prodExpAggregateBean,
    totalIncExpBean : data.totalIncExpBean,
    totalIncBean: data.totalIncBean,
    totalExpBean: data.totalExpBean,
    netIncAggregateBean: data.netIncAggregateBean
  };
  return JSON.stringify(oReturn);
}

function parseIncomeTransaction(data) {
  return JSON.stringify(data);
}

function parseNetIncAggregateBean(item) {
  return item;
}
 
function parseWeekData(item) {
  return {
    titleText: dateFormat(new Date(item.incDay),'ddd'),
    subTitleText: item.incDay,
    valueText: item.dayAggNetInc, 
    value: item.dayAggNetInc
  };
}

function parseYTDData(item) {
  return {
    titleText: item.incMth, 
    valueText: item.mthAggNetInc, 
    value: item.mthAggNetInc
  };
}

function parseMonthData(item) {
  return {
    titleText: item.incWk, 
    valueText: item.incWk,
    value: item.wkAggNetInc
  };
}

function parseResult(data) {
  return {
    data
  };
}

function parseChartAggregate(item) {
  return {
    week: item.incWeek,
    netIncome: item.wkAggNetInc
  };
}

function serviceFactory({ api }) {
  const getIncomeOverviewData = memoizer()(({ portfolioId, startDate, endDate, metaData }) =>
    api.getIncomeOverviewData(portfolioId, startDate, endDate, metaData)
      .then(parseIncomeOverviewData));
  const getIncomeOverviewLUXData = memoizer()(({ inputParam, metaData }) =>
    api.getIncomeOverviewLUXData(inputParam, metaData)
      .then(parseIncomeOverviewData))
  const getIncomeTransactionList = memoizer()(({ portfolioId, startDate, endDate, prodType, metaData }) =>
    api.getIncomeTransactionList(portfolioId, startDate, endDate, prodType, metaData)
    .then(parseIncomeTransaction));

  const getCHIncomeTransactionList = memoizer()(({ portfolioId, startDate, endDate, prodType, ieFlag, metaData }) =>
    api.getCHIncomeTransactionList(portfolioId, startDate, endDate, prodType, ieFlag, metaData)
    .then(parseIncomeTransaction));

  // const getIncomeOverviewCHData = memoizer()(({ portfolioId, startDate, endDate, selLanguageCode, metaData }) =>
  //   api.getIncomeOverviewCHData(portfolioId, startDate, endDate, selLanguageCode, metaData)
  //     .then(parseIncomeOverviewData));

  return {
    getIncomeOverviewData,
    getIncomeTransactionList,
    getCHIncomeTransactionList,
    getIncomeOverviewLUXData
    // getIncomeOverviewCHData
  };
}

module.exports = serviceFactory;
